module.exports = __webpack_public_path__ + "img/part-1-info.05be8588.png";